import classNames from 'classnames';
import { WidgetIcon } from 'components/ui-blocks/widget';
import React from 'react';
import { Card } from './Card';
import styles from './index.module.scss';

interface Props {
  className?: string;
  options?: unknown;
}

export const ReportPlaceholderCard = (props: Props) => {
  const { className, options, ...rest } = props;
  const containerClass = classNames(styles.reportCard, styles.placeholderReportCard, className);

  return (
    <Card className={containerClass} {...rest}>
      <div className={styles.widgets}>
        <WidgetIcon type="projects:list" />
        <div className={styles.divider} />
      </div>
      <div className={styles.description}>
        <div className={styles.placeholderHeading} />
        <div className={styles.placeholderParagraph} />
        <div className={styles.placeholderParagraph} />
        <div className={styles.placeholderParagraph} />
      </div>
    </Card>
  );
};
